import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Linkedin, Instagram, Youtube, Twitter } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_europe-guide/artifacts/rvgxr6ue_parrot.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Live Sessions', href: '/sessions' },
    { name: 'Book 1:1 Call', href: '/book-call' },
    { name: 'Profile Evaluation', href: '/profile-evaluation' },
  ];

  const countries = [
    { name: 'Germany', code: 'DE' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'France', code: 'FR' },
    { name: 'Spain', code: 'ES' },
    { name: 'Portugal', code: 'PT' },
  ];

  return (
    <footer data-testid="footer" className="bg-[#002A76] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="TieClad" 
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Honest & Ethical Immigration Advice for Indians who want to Study, Work & Settle in Europe.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://linkedin.com/company/tieclad" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://instagram.com/tieclad" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://youtube.com/@tieclad" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-youtube"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Youtube size={20} />
              </a>
              <a 
                href="https://twitter.com/tieclad" 
                target="_blank" 
                rel="noopener noreferrer"
                data-testid="social-twitter"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-gray-300 hover:text-[#0AA06A] transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular Countries */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Popular Countries</h4>
            <ul className="space-y-3">
              {countries.map((country) => (
                <li key={country.code}>
                  <Link 
                    to={`/country/${country.code}`}
                    data-testid={`footer-country-${country.code.toLowerCase()}`}
                    className="text-gray-300 hover:text-[#0AA06A] transition-colors text-sm"
                  >
                    {country.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Locations */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Get in Touch</h4>
            <div className="space-y-4">
              <a 
                href="mailto:info@tieclad.com"
                data-testid="footer-email"
                className="flex items-center gap-2 text-gray-300 hover:text-[#0AA06A] transition-colors text-sm"
              >
                <Mail size={16} />
                info@tieclad.com
              </a>
              <div className="space-y-2">
                <p className="text-sm font-medium text-gray-200 flex items-center gap-2">
                  <MapPin size={16} className="text-[#0AA06A]" />
                  Our Presence
                </p>
                <p className="text-gray-400 text-sm pl-6">Delhi, India</p>
                <p className="text-gray-400 text-sm pl-6">Berlin, Germany</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} TieClad. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
